import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Conflict-resolving class name composer — use everywhere instead of manual
 * template strings. Merges Tailwind utilities correctly (the last one wins).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
